export const languages = {
    en: 'English',
    zh: '中文',
    jp: '日本語',
    kr: '한국인',
    ru: 'Русский',
    tr: 'Türkçe',
    fr: 'Français',
    pt: 'Português',
    es: 'Español'
};

export type Language = keyof typeof languages;
